import { usePut } from '../../HttpClient';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';

export function useUpdateAccountStatus() {
  const put = usePut(true, "ams");
  const updateAccountStatus = (accountId: string, newAccountStatus: string, accountStatusReason?: string, effectiveDate?: string) => {
    
    if (effectiveDate === ""){
      effectiveDate = undefined;
    }
    
    return put(`/api/proxy/ams/account-service/account/${accountId}/status`, {
      newAccountStatus,
      accountStatusReason,
      effectiveDate
    });
  };

  return useMutationWithErrorHandling({
    mutationFn: ({ accountId, newAccountStatus, accountStatusReason, effectiveDate }: { accountId: string; newAccountStatus: string; accountStatusReason?: string, effectiveDate?: string }) =>
      updateAccountStatus(accountId, newAccountStatus, accountStatusReason, effectiveDate),
  });
}
